/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LoginByOtherSourceBody } from '../models/LoginByOtherSourceBody';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class GiteeLoginConrollerService {

    /**
     * PreLoginByGitee
     * @returns any OK
     * @throws ApiError
     */
    public static preLoginByGiteeUsingGet(): CancelablePromise<Record<string, Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/PreLoginByGitee',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }

    /**
     * loginByGitee
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static loginByGiteeUsingPost(
        requestBody?: LoginByOtherSourceBody,
    ): CancelablePromise<Record<string, Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/loginByGitee',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }


    /**
     * PreLoginByGitee
     * @returns any OK
     * @throws ApiError
     */
    public static preLoginByGiteeUsingGetFronted(): CancelablePromise<Record<string, Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/PreLoginByGiteeFronted',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }

    /**
     * loginByGitee
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static loginByGiteeUsingPostFronted(
        requestBody?: LoginByOtherSourceBody,
    ): CancelablePromise<Record<string, Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/loginByGiteeFronted',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }

}
